import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"
import { AjaxService } from 'src/app/shared/ajax.service'

@Component({
  selector: 'app-payback',
  templateUrl: './payback.component.html'
})
export class PaybackComponent implements OnInit {
  status: string
  authority: string
  constructor(private router: Router, private arout: ActivatedRoute, private ajax: AjaxService) { }

  ngOnInit() {
    this.status = this.arout.snapshot.queryParams["Status"]
    this.authority = this.arout.snapshot.queryParams["Authority"]
    //http://localhost:4200/payment/payback?Authority=000000000000000000000000000122378864&Status=OK

    if (this.status === 'OK') {
      this.ajax.execute({
        url: 'payment/payback',
        data: { authority: this.authority },
        success: (post) => {
          this.status = 'OK-REGISTERED'
        }
      })
    }
    else {
    }
  }
}
